import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  RULE_CONFIG_SECTIONS,
  readPath,
  displayValue,
} from '../rule-config-sections';

@Component({
  selector: 'app-rule-config-view',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rule-config-view.component.html',
})
export class RuleConfigViewComponent {
  @Input() config: unknown = null;
  @Input() lockedKeys: string[] = [];
  @Input() diff: Record<string, { old: unknown; new: unknown }> | null = null;

  readonly sections = RULE_CONFIG_SECTIONS;

  value(path: string): string {
    return displayValue(readPath(this.config, path));
  }

  isLocked(path: string): boolean {
    return this.lockedKeys.includes(path);
  }

  isChanged(path: string): boolean {
    return !!this.diff && Object.hasOwn(this.diff, path);
  }

  oldValue(path: string): string {
    return displayValue(this.diff?.[path]?.old);
  }
}
